import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import 'react-pivottable/pivottable.css';
import {
  Card,
  Grid,
  CardHeader,
  CardContent,
  Divider,
  Chip,
  Select,
  MenuItem,
  FormControl,
  Checkbox,
} from '@material-ui/core';
import { toJS } from 'mobx';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import ReportSnapshot from '../../reports/Report/ReportSnapshot';

const ReportsWidget = ({ dashboardConfig, rowIndex, widgetIndex }) => (
  <Observer
    render={() => {
      const [loading, setLoading] = useState(false);
      const [selectedReport, setSelectedReport] = useState(null);

      const { authStore, dataStore } = useRootStore();
      const reportTemplates = dataStore.reportArray;

      const updateDashConfig = async pref => {
        const payload = JSON.stringify(pref);
        try {
          await authStore.request.post(
            `${process.env.REACT_APP_API}/api/config`,
            {
              dashboardConfig: payload,
            },
          );
        } catch (e) {
          console.log(e);
        }
      };

      const handleChange = template => {
        const { TemplateId } = template;
        const curConfig = [...dashboardConfig];

        curConfig[rowIndex][widgetIndex].ReportId = TemplateId;

        setSelectedReport(template);
        updateDashConfig(curConfig);
      };

      useEffect(() => {
        const initialize = async () => {
          setLoading(true);
          if (reportTemplates.length === 0) {
            await dataStore.retrieveReports();
          }
          setLoading(false);
        };
        initialize();
      }, []);

      useEffect(() => {
        const curReport = dashboardConfig[rowIndex][widgetIndex];

        if (curReport && curReport.ReportId) {
          const foundReport = reportTemplates.find(
            ({ TemplateId }) => TemplateId === curReport.ReportId,
          );
          if (foundReport) setSelectedReport(foundReport);
        }
      }, [reportTemplates]);

      if (loading) return <Spinner />;

      const RenderReport = () => {
        const { TemplateId, Name } = selectedReport;
        return (
          <div key={TemplateId} style={{ boxSizing: 'border-box' }}>
            <ReportSnapshot reportId={TemplateId} />
          </div>
        );
      };

      return (
        <Grid item xs={12}>
          <Card>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <CardHeader
                title={selectedReport ? selectedReport.Name : 'Reports'}
              />
              <div style={{ padding: '12px 24px' }}>
                <FormControl variant="outlined" style={{ minWidth: '120px' }}>
                  <Select
                    displayEmpty
                    renderValue={value => value.Name}
                    value={selectedReport || {}}
                    placeholder="Select a report"
                  >
                    {reportTemplates.map(template => {
                      const { TemplateId, Name } = template;
                      return (
                        <MenuItem
                          key={TemplateId}
                          value={{ TemplateId, Name }}
                          onClick={() => handleChange(template)}
                        >
                          {Name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
            </div>
            <Divider />
            <CardContent>
              {selectedReport && <RenderReport />}

              {!selectedReport && <div>No Report Selected</div>}
            </CardContent>
          </Card>
        </Grid>
      );
    }}
  />
);

export default ReportsWidget;

//  <Link style={{ color: 'initial' }} to={`report/${TemplateId}`}>
//    {Name}
//  </Link>;
